import { render, staticRenderFns } from "./GoodsCapView.vue?vue&type=template&id=63296a70&"
import script from "./GoodsCapView.vue?vue&type=script&lang=js&"
export * from "./GoodsCapView.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCapView.vue?vue&type=style&index=0&id=63296a70&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports